import { CashType } from "./CashType";
import { Step } from "./Step";


export class Cash
{
    public readonly Type: CashType;
    public readonly Step: Step<any>;
    public readonly Amount: number;
    public readonly Description: string;
    public readonly When: Date;

    constructor(type: CashType, step: Step<any>, amount: number, description: string, when: Date)
    {
        this.Type = type;
        this.Step = step;
        this.Amount = amount;
        this.Description = description;
        this.When = when;
    }
}
